<template>
  <v-card flat>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="batches"
        :loading="loading"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <template #[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template #[`item.printedAt`]="{ item }">
          <span v-if="item.printedAt">{{ formatDate(item.printedAt) }}</span>
          <span v-else>Ikke skrevet ut</span>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            icon
            small
            @click="$emit('export', item)"
          >
            <v-icon color="primary">
              mdi-file-download
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IGiftCardBatchDTO } from "@shared/types";

@Component({
  name: "gift-card-batches-tab",
})
export default class GiftCardBatchesTab extends Vue {
  @Prop({ required: true }) batches!: IGiftCardBatchDTO[];
  @Prop({ default: false }) loading!: boolean;

  get headers() {
    return [
      { text: "Navn", value: "name" },
      { text: "Type", value: "giftCardType.name" },
      { text: "Antall", value: "quantity" },
      { text: "Opprettet", value: "createdAt" },
      { text: "Skrevet ut", value: "printedAt" },
      { text: "Handlinger", value: "actions", sortable: false },
    ];
  }

  public formatDate(date: string | Date | null | undefined): string {
    if (!date) return "-";
    const actual = typeof date === "string" ? new Date(date) : date;
    return actual.toLocaleDateString(this.$i18n.locale);
  }
}
</script>
